// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/kapi_notification.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message knop.ui.v1.model.KapiNotification
 */
export class KapiNotification extends Message<KapiNotification> {
  /**
   * The importance of this notification
   *
   * @generated from field: knop.ui.v1.model.KapiNotification.Level level = 1;
   */
  level = KapiNotification_Level.UNKNOWN;

  /**
   * The message of this notification, user-friendly and Dutch
   *
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * Optional: Indication which train/inzet this notification is relevant for
   *
   * @generated from field: knop.ui.v1.model.KapiNotification.TrainInfo train_info = 3;
   */
  trainInfo?: KapiNotification_TrainInfo;

  constructor(data?: PartialMessage<KapiNotification>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.KapiNotification";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "level", kind: "enum", T: proto3.getEnumType(KapiNotification_Level) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "train_info", kind: "message", T: KapiNotification_TrainInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KapiNotification {
    return new KapiNotification().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KapiNotification {
    return new KapiNotification().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KapiNotification {
    return new KapiNotification().fromJsonString(jsonString, options);
  }

  static equals(a: KapiNotification | PlainMessage<KapiNotification> | undefined, b: KapiNotification | PlainMessage<KapiNotification> | undefined): boolean {
    return proto3.util.equals(KapiNotification, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.model.KapiNotification.Level
 */
export enum KapiNotification_Level {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: INFORMATION = 1;
   */
  INFORMATION = 1,

  /**
   * @generated from enum value: WARNING = 2;
   */
  WARNING = 2,

  /**
   * @generated from enum value: ERROR = 3;
   */
  ERROR = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(KapiNotification_Level)
proto3.util.setEnumType(KapiNotification_Level, "knop.ui.v1.model.KapiNotification.Level", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "INFORMATION" },
  { no: 2, name: "WARNING" },
  { no: 3, name: "ERROR" },
]);

/**
 * Information to uniquely identify a train unit on a move on the hub
 *
 * @generated from message knop.ui.v1.model.KapiNotification.TrainInfo
 */
export class KapiNotification_TrainInfo extends Message<KapiNotification_TrainInfo> {
  /**
   * The code for the train movement
   *
   * @generated from field: string train_number = 1;
   */
  trainNumber = "";

  /**
   * The position of this unit during its inzet
   *
   * @generated from field: uint32 position_in_train = 2;
   */
  positionInTrain = 0;

  /**
   * The number of units in the consist during its inzet
   *
   * @generated from field: uint32 number_of_units_in_train = 3;
   */
  numberOfUnitsInTrain = 0;

  /**
   * Time of the inzet
   * note: this is converted in the backend from an implicit Europe/Amsterdam timezone to UTC
   *
   * @generated from field: google.protobuf.Timestamp time_info = 4;
   */
  timeInfo?: Timestamp;

  /**
   * Indication as to the kind of time information provided
   *
   * @generated from field: knop.ui.v1.model.KapiNotification.TrainInfo.TypeOfTimeInfo time_info_type = 5;
   */
  timeInfoType = KapiNotification_TrainInfo_TypeOfTimeInfo.UNKNOWN;

  constructor(data?: PartialMessage<KapiNotification_TrainInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.KapiNotification.TrainInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "train_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "position_in_train", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "number_of_units_in_train", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "time_info", kind: "message", T: Timestamp },
    { no: 5, name: "time_info_type", kind: "enum", T: proto3.getEnumType(KapiNotification_TrainInfo_TypeOfTimeInfo) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KapiNotification_TrainInfo {
    return new KapiNotification_TrainInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KapiNotification_TrainInfo {
    return new KapiNotification_TrainInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KapiNotification_TrainInfo {
    return new KapiNotification_TrainInfo().fromJsonString(jsonString, options);
  }

  static equals(a: KapiNotification_TrainInfo | PlainMessage<KapiNotification_TrainInfo> | undefined, b: KapiNotification_TrainInfo | PlainMessage<KapiNotification_TrainInfo> | undefined): boolean {
    return proto3.util.equals(KapiNotification_TrainInfo, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.model.KapiNotification.TrainInfo.TypeOfTimeInfo
 */
export enum KapiNotification_TrainInfo_TypeOfTimeInfo {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ARRIVAL_TIME = 1;
   */
  ARRIVAL_TIME = 1,

  /**
   * @generated from enum value: DEPARTURE_TIME = 2;
   */
  DEPARTURE_TIME = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(KapiNotification_TrainInfo_TypeOfTimeInfo)
proto3.util.setEnumType(KapiNotification_TrainInfo_TypeOfTimeInfo, "knop.ui.v1.model.KapiNotification.TrainInfo.TypeOfTimeInfo", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "ARRIVAL_TIME" },
  { no: 2, name: "DEPARTURE_TIME" },
]);

